<template>
<div id="model-show">
  <!--loadingPage-->
  <loading-page ref="loading" class='loading-page'></loading-page>
  <!--model demo-->
  <model-demo ref="modelDemo" class='model-demo'></model-demo>
  <!-- 弹幕 -->
  <modelBullet ref="modelBullet" class="model-bullet" :isPlay='isOpenBullet'></modelBullet>
  <!--logo return button-->
  <div class="left-top-container" v-show="!measureButton && !heatMap">
    <div class="left-top-box">
      <!--返回按钮-->
      <div class="back-button-box" v-if="isSwitchReturnLink" @click="goBack">
        <img :src="backIcon" alt="" class="back-image">
      </div>
      <!--logo-->
      <div class="logo-box" v-if="isShowLogo">
        <img :src="logo" alt="" class="logo">
      </div>
    </div>
    <!--人气值-->
    <div class="poplarity-value-box" v-if="isShowPopularity">
      <span class="value">人气值: {{parseFloat(popularityValue).toFixed(2)}}万</span>
    </div>
    <div id="compassoutdoor-box" v-if="isShowCompass">
      <div id="compassoutdoor"></div>
      <div id="indoorscale"></div>
      <div id="indoor"></div>
    </div>
  </div>
  <div class="hud-container" v-show="!measureButton && !isPlayGuide">
    <!--scene controllbar container-->
    <div ref="flatButton" class="flat-controll-bar-container"  :class="{'flat-controll-bar-box-active' : isIn3D, 'flat-controll-bar-box' : !isIn3D ,'flat-controll-bar-box-active-noSceneShow' : (isIn3D && !sceneShow)}">
      <div class="flat-box" >
        <div :class="item.active ? 'flat-button-active' : 'flat-button'" v-for="(item,index) in flat" :key="'flat-button-'+index" @click="changeModelFlat(index)">
          <img :src="item.src">
          <span class="flat-text">{{item.text}}</span>
        </div>
      </div>
    </div>
    <div ref="sceneControllBarContainer" class="scene-controll-bar-container" :class="sceneShow ? 'scene-controll-bar-container-active' : 'scene-controll-bar-container'" v-if="controll" :style="{bottom:sceneControllBottom+'px'}">
      <div ref='sceneControllBar' class="scene-controll-bar-box">
        <div class="controll-left-box">
          <div class="model-menu-box" @click="showSceneList">
            <img ref="menuIcon" :src="menuIcon" class="model-menu-icon">
          </div>
          <div class="model-player-box">
            <div class="model-pause-box" v-if="!isViewAutoPlay" @click='autoPlay'>
              <img ref="pauseIcon" :src="pauseIcon" alt="" class="model-pause-icon">
            </div>
            <div class="model-play-box" v-if="isViewAutoPlay">
              <div class="model-play-icon-box" @click='pausePlay'>
                <img ref="playIcon" :src="playIcon" alt="" class="model-play-icon">
              </div>
              <div class="line"></div>
              <div class="speed-box">
                <span class="speed" @click="showSpeedList">{{currentSpeed}}</span>
                <ul :class="isShowSpeedList ? 'speed-list-active' : 'speed-list'">
                  <li class="speed-item" v-for="(item,index) in speedList" :key="'speed-'+index" @click="selectSpeed(index)">{{item.key}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="controll-center-box">
          <div class="model-description-icon-box">
            <img ref="descriptionIcon" :src="descriptionIcon" alt="" class="model-description-icon" @click="showModelDescription">
          </div>
          <div class="model-vr-icon-box" v-show="isSwitchVr" @mouseenter="showPcVr" @mouseleave="hidePcVr">
            <img ref="vrIcon" :src="vrIcon" class="model-vr-icon" @click="showMobileVr">
            <!--vr提示信息-->
            <div class="vr-tip-box" v-if="isShowPcVr">
              <div class="vr-qr-code-box" ref="qrCodeDivVr"></div>
              <!-- <div class="vr-qr-code-box">
                <img :src="vrQrCode" alt="" class="vr-qr-code">
              </div> -->
              <div class="vr-tip-info-box">
                <div class="vr-tip-info">
                  <p>手机扫一扫即可体验VR/重力感应</p>
                </div>
              </div>
            </div>
            <div class="vr-option-box" v-show="isShowMobileVr">
              <ul class="vr-option-list">
                <li class="vr-option-item" @touchend="openGravitySensor">
                  <img :src="gravityIcon" alt="" class="option-gravity">
                </li>
                <li class="vr-option-item" @touchend="openVR">
                  <img :src="optionVrIcon" alt="" class="option-vr">
                </li>
              </ul>
            </div>
          </div>
          <div class="model-bullet-box" v-if="isSwitchBullet">
            <img :src="switchBulletIcon" alt="" class="model-bullet-icon" ref='bulletSwitchIcon' @click="switchBullet">
            <div class="bullet-option-box" v-if="isShowBulletList">
              <ul class="bullet-option-list">
                <li class="bullet-option-item" v-if='isInWeixin'>
                  <img :src="mesBulletIcon" alt="" class="bullet-mes" >
                </li>
                <li class="bullet-option-item">
                  <img :src="bulletOffIcon" alt="" class="mobile-bullet-switch">
                </li>
              </ul>
            </div>
          </div>
          <div v-if="!onlyPano" class="model-flat-icon-box">
            <img v-if="!onGod" :src="bottom3D" alt="" class="model-description-icon" @click="viewChange()">
            <img v-else :src="bottomFlat" alt="" class="model-description-icon" @click="viewChange()">
          </div>
        </div>
        <!-- <div class="controll-right-box" v-show='!isViewAutoPlay'> -->
        <div class="controll-right-box" v-show='false'>
          <div class="model-editor-box" @click="showMobileSpace">
            <img ref="editorIcon" :src="modelEditor" class="model-editor-icon">
          </div>
        </div>
      </div>
    </div>
    <!--scene list container-->
    <div ref='modelSceneListBox' :class="sceneShow  ? 'model-scene-list-box-active' : 'model-scene-list-box'" v-if="scene">
      <model-scene :data="sceneList" ref="modelScene" :editor="editor"></model-scene>
    </div>
    <!--右侧工具栏-->
    <div class="right-option-box" id="right-Bar">
      <div class="right-tool-column-box" v-if="tool">
        <img ref="answerIcon" :src="answerIcon" class="icon-model-answer" @click="openHelpInfoDialog" />
        <img v-if="isSwitchMusic" ref="musicIcon" :src="musicIcon" @click="switchModelMusic" />
        <img v-if="isSwitchMap" ref="outMapIcon" :src="outMapIcon" class="icon-model-position" @click="showMap" />
        <img v-if="isSwitchShare" ref="shareIcon" :src="shareIcon" class="icon-model-share" @click="showShare" />
        <img ref="fullScreenIcon" :src="fullIcon" class="icon-model-fullscreen" @click="enterFullScreen" v-if="!isMobile" />
      </div>
    </div>
    <!--地图关闭按钮-->
    <div class="model-map-container" v-if="isSwitchModelPosition" @click.self="closeModelPosition">
      <div class="map-close-button-box" @click="closeModelPosition">
        <i class="iconfont icon-close" style="color:#DCDCDC"></i>
      </div>
      <!--地图-->
      <div class="exhibition-inline-map">
        <div id="container">
          <el-amap class="amap-box" :vid="'amap-vue'" :zoomEnable="model.maps.enable" :plugin="model.maps.plugin" :dragEnable="model.maps.enable" :zoom="model.maps.zoom" :center="model.maps.center">
            <div v-for="(item,index) in model.maps.markpoint" :key="'mark-'+index">
              <el-amap-marker :position="item.point" :lable="item.name" :clickable="item.enableclick" :events="model.markerEvents"></el-amap-marker>
            </div>
          </el-amap>
        </div>
      </div>
    </div>
  </div>
  <!--背景音乐-->
  <div class="background-music-box">
    <audio :src="bgMusicSrc" id="model-bgm" @click="playMusic"></audio>
    <audio :src="voiceSrc" id="model-intor" v-if="isVoice"></audio>
  </div>
  <!--Pc端推荐空间-->
  <!-- <div :class="isShowPcRecommendSpace ? 'pc-recommend-container-active' : 'pc-recommend-container'" v-if="!isMobile && !heatMap"> -->
  <div :class="isShowPcRecommendSpace ? 'pc-recommend-container-active' : 'pc-recommend-container'" v-if="false">
    <div class="space-recommend-box" v-show="!isViewAutoPlay">
      <div class="space-recommend-top">
        <span :class="{'active':item.active, 'more-space':(item.name==='更多空间'), 'technology-space':(item.name!=='更多空间')}" v-for="(item, index) in mobileRecommendLableList" :key="index" @click="changeSpace(index)">{{item.name}}</span>
      </div>
      <div class="space-list-box">
        <ul class="space-list" ref="spaceList">
          <li ref="spaceListItem" class="space-list-item" v-for="item in activeDataList" :key="'space-'+item.id">
            <div class="thumbnail-box">
              <img :src="item.src" class="thumbnail-img" @click="recommenedRedirect(item)">
            </div>
            <div class="space-name-box">
              <span class="space-name">{{item.name | ellipsis(22)}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="pc-recommend-space-option-box">
        <span class="dot"></span>
        <img :src="modelPauseIcon" @click="playAnimate" alt="" class="recommend-play-icon">
      </div>
    </div>
    <div class="hide-button-box" @click="showPcRecommendSpace" v-show="!isViewAutoPlay">
      <i class="iconfont" :class="isShowPcRecommendSpace ? 'icon-arrow-left' : 'icon-arrow-right'"></i>
    </div>
  </div>
  <!--移动端推荐空间-->
  <!-- <div :class="isShowSpace ? 'mobile-space-recommend-box-active' : 'mobile-space-recommend-box'" > -->
  <div :class="isShowSpace ? 'mobile-space-recommend-box-active' : 'mobile-space-recommend-box'" v-if="false">
    <div class="mobile-top-menu-box">
      <ul class="mobile-space-list">
        <li :class="item.active ? 'mobile-space-item-active' : 'mobile-space-item'" v-for="(item,index) in mobileRecommendLableList" :key="'space-lable-'+index" @click="changeSpace(index)">
          <span class="mobile-more-space">{{item.name}}</span>
        </li>
      </ul>
      <div class="mobile-space-play-box">
        <img :src="modelSpacePlayIcon" @click="playAnimate" alt="" class="mobile-space-play-icon">
      </div>
      <div class="mobile-space-arrow-down-box" @click="hideMobileSpace">
        <img :src="modelSpaceArrowDown" alt="" class="mobile-space-play-icon">
      </div>
    </div>
    <div class="mobile-space-list-box" ref="mobileSpaceListBox">
      <ul ref="mobileSpaceRecommendList" class="mobile-space-recommend-list">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item,index) in mobileDataList" :key="'space-page-'+index">
            <div class="mobile-space-list-item-box">
              <li ref="mobileSpaceItem" class="mobile-space-list-item" v-for="(space,spacekey) in item" :key="'mobile-'+spacekey">
                <div class="mobile-thumbnail-box">
                  <img :src="space.src" class="mobile-space-image" @click="recommenedRedirect(space)">
                </div>
                <div class="mobile-space-name-box">
                  <span class="mobile-space-name">{{space.name | ellipsis(12)}}</span>
                </div>
              </li>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </ul>
    </div>
  </div>
  <!--model description container-->
  <div class="model-description-container" v-if="isShowModelDescription" @click.self="closeDescription">
    <div class="model-description-box">
      <div class="top-menu-box">
        <i class="iconfont icon-close" @click="closeDescription"></i>
      </div>
      <div class="center-content-box">
        <ul class="model-info-list">
          <li class="model-info-item">
            <!-- <div class="left-lable-box">
              <span class="left-lable">名称</span>
            </div> -->
            <div class="right-content-box model-name-box">{{model.name}}</div>
          </li>
          <li class="model-info-item model-info-item-description">
            <!-- <div class="left-lable-box">
              <span class="left-lable">简介</span>
            </div> -->
            <div class="model-abstract-box" v-html="model.description"></div>
          </li>
          <li class="model-info-item" v-if="model.isShowMaker">
            <!-- <div class="left-lable-box">
              <span class="left-lable">出品人</span>
            </div> -->
            <div class="right-content-box">{{"出品人: "+model.maker}}</div>
          </li>
          <li class="model-info-item" v-if="model.isShowAddress">
            <!-- <div class="left-lable-box">
              <span class="left-lable">联系地址</span>
            </div> -->
            <div class="right-content-box">{{"联系地址: "+model.address}}</div>
          </li>
          <li class="model-info-item" v-if="model.isShowPhone">
            <!-- <div class="left-lable-box">
              <span class="left-lable">联系电话</span>
            </div> -->
            <div class="right-content-box phone-option-container">
              <span>{{"联系电话: "+ model.phone}}</span>
              <img ref="modelPhoneIcon" :src="phoneIcon" alt="" class="model-phone-icon" v-if="isMobile" @click="showPhoneOption">
              <ul class="phone-option-list" v-if="isShowPhoneOption">
                <li class="option-item option-copy" @click="copyContent">复制</li>
                <li class="option-item option-call"><a :href="callPhoneUrl">呼叫</a></li>
                <li class="option-item option-add"><a :href="addPhoneNumberUrl">添加到通讯录</a></li>
              </ul>
            </div>
          </li>
          <li class="model-info-item" v-if="model.isShowTechniqueSupport">
            <!-- <div class="left-lable-box">
              <span class="left-lable">技术支持</span>
            </div> -->
            <div class="right-content-box">{{"技术支持: "+model.techniqueSupport}}</div>
          </li>
          <li class="model-info-item model-info-item-qr-code" v-if="model.isShowQrcode">
            <!-- <div class="left-lable-box">
              <span class="left-lable">二维码</span>
            </div> -->
            <!-- <div class="right-content-box model-qr-code" ref="qrCodeDiv"></div> -->
            <div class="right-content-box model-qr-code">
              <img :src="model.qrCode" alt="二维码加载失败" style="width:60px; height:60px;">
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- todo 动态显示 -->
  <modelMeasure ref='measure' class="" v-show='true || isShowMeasure'></modelMeasure>
  <!-- vrExit button -->
  <div class="vr-exit-box" v-if="vrMode" @click="exitVR">
    <img :src="vrExit" alt="" class="vr-exit-icon">
  </div>
  <my-dialog :show="show" :type="dialogType"></my-dialog>
  <!-- 弹幕输入弹窗 -->
  <div class="bullet-input-mask-layer" v-show='isShowBulletInput'>
    <div class="bullet-input-box">
      <div class="bullet-input-title">
        <div class="bullet-input-title-text">发射弹幕</div>
      </div>
      <div class="bullet-input-content">
        <Input v-model="bulletValue" placeholder="发个弹幕见证当下......" />
      </div>
      <div class="bullet-input-confirm">
        <ButtonGroup class="bullet-input-button-group">
          <Button @click="cancelShootBullet" class="bullet-input-cancel">取消</Button>
          <Button type="primary" :loading="bulletShooting" @click="shootBullet" class="bullet-input-shoot">
            <span v-if="!bulletShooting">发射</span>
            <span v-else>发射中...</span>
          </Button>
        </ButtonGroup>
      </div>
    </div>
  </div>
  <div class="controll-right-box controll-right-box-copy" v-show='isPlayGuide'>
    <div class="model-editor-box" @click="showMobileSpace">
      <img :src="modelEditor" class="model-editor-icon">
    </div>
  </div>
  <!-- <Modal
    class="bullet-input"
    title="发射弹幕"
    v-model="isShowBulletInput"
    :closable="false"
    :loading="true"
    @on-ok="shootBullet">
    <Input v-model="bulletValue" placeholder="发个弹幕见证当下......"/>
  </Modal> -->
  <div class="guide-container" @click="closeHelpInfoDialog" v-if="isShowAnswerDialog">
    <div class="guide-content-container" v-if="isShowAnswerDialog">
      <img :src="guideCloseIcon" class="close-icon" @click="closeHelpInfoDialog">
    </div>
  </div>
</div>
</template>

<script>
import {
  SettingJsonToApiJson
} from '@/components/modeldemo/Tool/Json2Request.js'
import modelBullet from '@/components/modeldemo/modelBullet'
import modelDemo from '@/components/modeldemo/ModelDemo'
import modelScene from '@/components/modeldemo/modelScene'
import loadingPage from '@/components/modeldemo/LoadingPage'
import myDialog from '@/components/dialog/MyDialog'
import modelMeasure from '@/components/modeldemo/MeasureComp/MeasureComp'
import {
  GravitySensor
} from '@/components/modeldemo/Input/Motion'
import {
  getPlatform,
  perfixInt,
  coverImagePath,
  waitFor
} from '@/components/modeldemo/Utils'
import {
  Swiper,
  SwiperSlide,
  directive
} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {
  Compass
} from "@/components/modeldemo/Compass"
import {
  Barrage
} from '@/components/modeldemo/Barrage'
import {
  config
} from '@/components/modeldemo/config';
import {
  Events
} from './Events'
import {
  isWeixin,
  detectIOS
} from '@/components/modeldemo/Device/Browser.js'
import {
  strToMatrix,
  strToNumberArray
} from './Utils'
import * as Statistic from './Statistic'
import {
  appid,
  redirect_uri
} from './WXconfig.json'
import QRCode from 'qrcodejs2'
import getModelId from '@/components/GetModelId.js'
export default {
  name: 'modelShow',
  components: {
    loadingPage,
    modelBullet,
    modelDemo,
    modelScene,
    myDialog,
    Swiper,
    SwiperSlide,
    modelMeasure
  },
  props: {
    scene: {
      type: Boolean,
      default: true
    },
    editor: {
      type: Boolean,
      default: false
    },
    controll: {
      type: Boolean,
      default: false,
    },
    tool: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false
    },
    heatMap: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    ellipsis(value, maxlen) {
      if (!value) return '暂无名称'
      let realStringLength = 0,
        charCodeValue = -1,
        charCount = 0;
      for (let i = 0, len = value.length; i < len; i++) {
        charCodeValue = value.charCodeAt(i);
        if (charCodeValue >= 0 && charCodeValue <= 128) realStringLength += 1;
        else realStringLength += 2;

        if (realStringLength < maxlen) charCount++
      }
      if (realStringLength > maxlen) {
        return value.slice(0, charCount) + '...'
      }
      return value
    }
  },
  data() {
    return {
      isInWeixin: false,
      bulletShooting: false,
      bulletValue: '',
      isShowBulletInput: false,
      isShowMeasure: true,
      isIn3D: false,
      isShowFlatButton: false,
      flat: [{
          src: require('@/assets/img/icon/flat-unselect.png'),
          text: '平面',
          active: false
        },
        {
          src: require('@/assets/img/icon/3D-selected.png'),
          text: '3D',
          active: true
        }
      ],
      onlyPano: false,
      onGod: false,
      bottom: 250,
      modelName: '',
      sceneShow: true,
      sceneControllBottom: 190,
      perspectiveChange: false,
      bgIsPlay: false,
      isViewAutoPlay: false,
      isShowSpeedList: false,
      speedList: [{
          key: '0.1x',
          value: 20000
        },
        {
          key: '0.2x',
          value: 10000
        },
        {
          key: '0.3x',
          value: 6666
        },
        {
          key: '0.5x',
          value: 4000
        },
        {
          key: '1.0x',
          value: 2000
        },
        {
          key: '1.5x',
          value: 1333
        },
        {
          key: '2.0x',
          value: 1000
        },
      ],
      currentSpeed: '倍速',
      isShowModelDescription: false,
      isShowVrTip: false,
      isMobile: false,
      isShowSceneList: false,
      currentActiveId: -1,
      starter: null,
      isShowAnswerDialog: false,
      isOffMusic: true,
      isSwitchModelPosition: false,
      isFullScreen: false,
      isShare: false,
      bgMusicSrc: "",
      voiceSrc: "",
      isVoice: false,
      dialogType: 'transparent',
      pointLength: 0,
      sceneList: [],
      screenWidth: 0,
      isShowPcVr: false,
      isShowMobileVr: false,
      changeButtonClass: '',
      isOpenBullet: false,
      model: {
        name: '建设银行',
        description: '',
        isShowMaker: true,
        maker: '',
        isShowAddress: true,
        address: '',
        addressLocation: {
          lon: 0,
          lan: 0
        },
        isShowPhone: true,
        phone: '',
        isShowTechniqueSupport: true,
        techniqueSupport: '',
        isShowQrcode: true,
        qrCode: '',
        maps: {
          enable: true,
          enableclick: true,
          markevent: 'click',
          zoom: 15,
          center: [118.825064, 32.040802],
          markpoint: [{
            name: {
              content: '中国建设银行',
              offset: [20, 20]
            },
            point: [118.825064, 32.040802]
          }],
          plugin: ['AMap.Scale']
        },
        markerEvents: {
          click(e) {
            // console.log(e);
          }
        }
      },
      isShowBulletList: false,
      mobileRecommendLableList: [{
          name: '更多空间',
          active: true,
          data: []
        },
        {
          name: '导览标题',
          active: false,
          data: []
        }
      ],
      isShowSpace: false,
      indicatorCount: 0,
      mobileDataList: [],
      mobileTouchStartX: 0,
      mobileTouchEndX: 0,
      activeIndex: 0,
      distance: 0,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        slidesPerview: 0,
      },
      activeDataList: [],
      isSwitchMusic: true,
      isSwitchMap: false,
      isSwitchShare: false,
      isSwitchReturnLink: false,
      isSwitchVr: false,
      //控制显示弹幕控件
      isSwitchBullet: false,
      isShowPopularity: false,
      popularityValue: 0,
      isShowCompass: true,
      isShowLogo: true,
      isShowPcRecommendSpace: false,
      measureButton: false,
      guideCloseIcon: require('@/assets/img/icon/guide-close.png'),
      backIcon: require('@/assets/img/icon/model-back.png'),
      logo: require('@/assets/img/logo/logo.png'),
      menuIcon: require('@/assets/img/icon/model-menu.png'),
      pauseIcon: require('@/assets/img/icon/model-pause.png'),
      playIcon: require('@/assets/img/icon/model-play.png'),
      descriptionIcon: require('@/assets/img/icon/description.png'),
      vrIcon: require('@/assets/img/icon/model-vr.png'),
      vrQrCode: require('@/assets/img/icon/vr_qr_code.png'),
      gravityIcon: require('@/assets/img/icon/gravity.png'),
      optionVrIcon: require('@/assets/img/icon/VR.png'),
      switchBulletIcon: require('@/assets/img/icon/off-bullet.png'),
      mesBulletIcon: require('@/assets/img/icon/bullet-mes.png'),
      bulletOffIcon: require('@/assets/img/icon/bullet-on.png'),
      bottom3D: require('@/assets/img/icon/bottom-pc-3D.png'),
      bottomFlat: require('@/assets/img/icon/bottom-pc-flat.png'),
      modelEditor: require('@/assets/img/icon/model-editor.png'),
      answerIcon: require('@/assets/img/icon/mobile-answer.png'),
      musicIcon: require('@/assets/img/icon/mobile-music-on.png'),
      outMapIcon: require('@/assets/img/icon/mobile-out-map.png'),
      fullIcon: require('@/assets/img/icon/fullscreen.png'),
      shareIcon: require('@/assets/img/icon/mobile-share.png'),
      modelPauseIcon: require('@/assets/img/icon/pause.png'),
      modelSpacePlayIcon: require('@/assets/img/icon/mobile-space-play.png'),
      modelSpaceArrowDown: require('@/assets/img/icon/mobile-space-arrow-down.png'),
      phoneIcon: require('@/assets/img/icon/phone.png'),
      ready: false,
      vrExit: require('@/assets/img/icon/bottom-pc-flat.png'),
      vrMode: false,
      isPlayGuide: false,
      isShowPhoneOption: false,
      callPhoneUrl: 'tel:',
      addPhoneNumberUrl: 'wai:',
    }
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        el.click();
      }
    }
  },
  created() {
    // this.handleWX()
    this.isInWeixin = !!isWeixin()
    // console.log("query",this.$route)
  },
  mounted() {
    document.addEventListener('wheel', (e) => {});
    //监听esc键，确保按下esc退出全屏后，继续点击进入全屏图标依然可以进入和退出全屏
    window.addEventListener('resize', this.listenESC);

    // if (getPlatform().platform !== 'pc') {
    //   // 移动端横屏时
    //   this.mobileHorizontalScreen();
    //   window.addEventListener('resize', this.mobileHorizontalScreen);
    // }
    // document.addEventListener('touchstart', (e) => {})

  },
  methods: {
    // 调用子组件事件 - 更新视图窗体
    resizeContent() {
      this.$refs.modelDemo && this.$refs.modelDemo.onWindowResize()
    },
    async init(inputSetting, isEditPoint = false) {
      // 转换
      this.settings = inputSetting

      // 预处理mgrap
      // console.log(this.settings)
      if (this.settings.model.mgraph) {
        this.settings.model.mgraph = strToMatrix(this.settings.model.mgraph)
        for(const col of this.settings.model.mgraph) {
          for(let colIdx = 0; colIdx < col.length; colIdx ++) {
            if(col[colIdx] === 65535){
              col[colIdx] = config.CPoint.DistMax
            }
          }
        }
      }
      const mSettings = this.settings.model

      Statistic.startVisit(mSettings.modelPkId);
      //this.$http("/api/recordVisit/recordVisit", sv, 'POST')
      /*
      this.$axios({
        baseURL:'/docking',
        url:"/api/recordVisit/recordVisit",
        method:'POST',
        data:sv
      })
      */
      this.modelName = mSettings.modelName;
      /*测量功能开关*************************************/
      this.isMeasureable = mSettings.isMeasureEnable
      /*右侧********************************************/
      this.isSwitchMusic = mSettings.modelBackgroundMusic ? mSettings.isSwitchBackgroundMusic : false;
      this.bgMusicSrc = mSettings.modelBackgroundMusic ? mSettings.modelBackgroundMusic : undefined
      this.isVoice = mSettings.isVoice
      this.voiceSrc = mSettings.modelVoiceUrl
      this.isSwitchMap = mSettings.isSwitchOutlineMap;
      this.isSwitchShare = mSettings.isSwitchShareable;

      /*左上角********************************************/
      this.isSwitchReturnLink = mSettings.isSwitchReturnLink;
      // todo 返回函数
      this.isSwitchReturnLink ? this.returnLink = mSettings.modelReturnLink : undefined;
      this.isShowPopularity = mSettings.isShowPopularity;
      this.popularityValue = mSettings.popularityValue
      this.isShowLogo = mSettings.isShowModelLogo;
      this.logo = mSettings.modelLogo;
      // todo 配置logo

      /*中下********************************************/
      this.perspectiveChange = mSettings.modelIndexEnterType === 3;
      this.onlyPano = mSettings.modelShowType === 1
      this.isSwitchVr = mSettings.isSwitchModelVr;
      this.isSwitchBullet = mSettings.isShowBarrage;

      /*描述弹窗********************************************/
      // todo 配置是否显示
      this.model.name = mSettings.modelName;
      this.model.description = mSettings.modelDescription;
      this.model.isShowMaker = mSettings.isShowMaker;
      this.model.maker = mSettings.modelMaker;
      this.model.isShowAddress = mSettings.isShowAddress;
      this.model.address = mSettings.modelAddress;
      this.model.isShowPhone = mSettings.isShowPhoneNumber;
      this.model.phone = mSettings.modelPhoneNumber;
      this.callPhoneUrl = 'tel:' + this.model.phone;
      this.addPhoneNumberUrl = 'wtai://wp/ap;' + this.model.phone + ";";
      this.model.isShowTechniqueSupport = mSettings.isShowTechnologySupport;
      this.model.techniqueSupport = mSettings.modelTechnologySupport;
      this.model.isShowQrcode = mSettings.isShowModelQrcode;
      this.model.qrCode = mSettings.modelQrcode;

      /********************************************/
      // 推荐空间
      this.mobileRecommendLableList[1].name = mSettings.guideTitle;
      this.settings.recommendModelVOList.forEach((item, index) => {
        this.mobileRecommendLableList[0].data.push({
          modelPkId: item.modelId,
          name: item.modelName,
          src: item.pcBg
        })
      })
      /********************************************/

      /********************************************/
      // 场景列表
      this.sceneList = this.formatScene(this.settings)
      if (!this.$props.scene) {
        this.bottom = 60;
      }
      if (this.$props.scene) {
        this.sceneShow = true;
      } else {
        this.sceneShow = false;
      }

      /********************************************/
      // 热点导览页面
      let counter = 0
      for (const i of this.settings.guideList) {
        const hpType = {
          id: i.guideId,
          name: i.guideName,
          src: i.guideCoverUrl,
          type: i.guideType,
          hotpointId: i.guideHotpointId,
          pointId: ""
        }
        this.mobileRecommendLableList[1].data.push(hpType)
      }
      /*热力图问题*********************************/
      if (this.heatMap) {
        mSettings.modelShowType = 2
        mSettings.modelIndexEnterType = 1
      }

      /*******************************************/
      let start = () => {}
      if(this.settings.model.modelPkId === '2t4vQ2KZ') {
      } else {
        start = this.startMediaPlay
      }
      this.$refs.loading.init(mSettings, start);
      /*****************emitter*******************/
      this.$refs.modelDemo.$once('onSceneReady', this.addListener.bind(this))
      this.$refs.modelDemo.$once('onSceneReady', this.playMusic.bind(this))
      this.$refs.modelDemo.$once('onSceneReady', this.$refs.loading.finishLoading.bind(this))
      this.$refs.modelDemo.$once('onSceneReady', (() => this.onGod = !this.$refs.modelDemo._camera.cameraMode).bind(this))
      this.$refs.modelDemo.$once('onSceneReady', this.initCompass.bind(this))
      this.$refs.modelDemo.$once('onSceneReady', this.initMeasure.bind(this))
      this.$refs.modelDemo.$once('onSceneReady', () => {parent.postMessage({type:Events.SceneReady, msg: {}}, '*')})
      this.$refs.modelDemo.$on('loadingTo', this.$refs.loading.loadingTo)

      this.$refs.loading.$once(Events.CancelLoading, this.enterModel)
      this.$refs.loading.$once(Events.CancelLoading, () => {parent.postMessage({type:Events.CancelLoading, msg: {}}, '*')})
      /********************************************/
      this.$refs.modelDemo.run(this.settings, isEditPoint)

      // 根据屏幕宽高，自动适配控制条宽高
      this.screenWidth = window.screen.width;
      const ua = getPlatform();
      if (ua.platform !== 'pc' || (this.screenWidth > 0 && this.screenWidth <= 780)) {
        this.bottom = 160;
        this.sceneControllBottom = 120;
        this.isMobile = true;
        this.isShowPcVr = false;
      }

      // 自动是切换不同平台下的图标
      if (this.isMobile) {
        this.$nextTick(() => {
          console.info('此处是否执行！')
          this.answerIcon = require('@/assets/img/icon/mobile-answer.png');
          this.menuIcon = require('@/assets/img/icon/mobile-menu.png');
          this.pauseIcon = require('@/assets/img/icon/mobile-pause.png');
          this.descriptionIcon = require('@/assets/img/icon/mobile-description.png');
          this.bottom3D = require('@/assets/img/icon/bottom-mobile-3D.png'),
            this.bottomFlat = require('@/assets/img/icon/bottom-mobile-flat.png'),
            this.editorIcon = require('@/assets/img/icon/mobile-editor.png');
            this.flat[0].src = require('@/assets/img/icon/mobile-flat-select.png');
            this.flat[1].src = require('@/assets/img/icon/mobile-3D-selected.png');
          if (this.playIcon !== undefined) {
            this.playIcon = require('@/assets/img/icon/model-play.png');
          }
          this.vrIcon = require('@/assets/img/icon/mobile-vr.png');
          this.switchBulletIcon = require('@/assets/img/icon/mobile-bullet-off.png');
          if (this.isSwitchMusic) {
            this.musicIcon = require('@/assets/img/icon/mobile-music-on.png');
          }
          if (this.isSwitchMap) {
            this.outMapIcon = require('@/assets/img/icon/mobile-out-map.png');
          }
          if (this.isSwitchShare) {
            this.shareIcon = require('@/assets/img/icon/mobile-share.png');
          }
        });

      } else {
        this.$nextTick(() => {
          this.answerIcon = require('@/assets/img/icon/answer.png');
          this.menuIcon = require('@/assets/img/icon/model-menu.png');
          this.pauseIcon = require('@/assets/img/icon/model-pause.png');
          this.descriptionIcon = require('@/assets/img/icon/description.png');
          if (this.playIcon !== undefined) {
            this.playIcon = require('@/assets/img/icon/model-play.png');
          }
          this.editorIcon = require('@/assets/img/icon/model-editor.png');
          this.vrIcon = require('@/assets/img/icon/model-vr.png');
          this.switchBulletIcon = require('@/assets/img/icon/off-bullet.png');
          if (this.isSwitchMusic) {
            this.musicIcon = require('@/assets/img/icon/model-music-on.png');
          }
          if (this.isSwitchMap) {
            this.outMapIcon = require('@/assets/img/icon/out_map.png');
          }
          if (this.isSwitchShare) {
            this.shareIcon = require('@/assets/img/icon/facebook_share.png');
          }
        });
      }
      // 初始化 activeDataList
      this.activeDataList = this.mobileRecommendLableList[0].data;

      //调整推荐空间的内容样式
      this.switchStyles();

      // 由于指南针设置了绝对定位，因此父元素只能通过js动态设置宽高来控制子元素
      let compassOutDoor = document.querySelector('#compassoutdoor');
      let compassWidth = parseInt(document.defaultView.getComputedStyle(compassOutDoor, null).width.split('px')[0]);
      let compassHeight = parseInt(document.defaultView.getComputedStyle(compassOutDoor, null).height.split('px')[0]);
      let compassContaier = document.querySelector('#compassoutdoor-box');
      compassContaier.style.width = compassWidth + 'px';
      compassContaier.style.height = compassWidth + 'px';
      // 实现vr和弹幕列表的动态显示和隐藏
      if (this.isMobile) {
        document.addEventListener('touchstart', (e) => {
          let targetElement = e.target.className;
          if (targetElement === 'model-vr-icon') {
            this.isShowMobileVr = !this.isShowMobileVr;
          } else {
            setTimeout(() => {
              this.isShowMobileVr = false;
            }, 300);
            // this.isShowMobileVr = false;
          }

          if (targetElement === 'model-bullet-icon') {
            this.isShowBulletList = !this.isShowBulletList;
          } else {
            this.isShowBulletList = false;
          }

          if (targetElement === 'mobile-bullet-switch') {
            this.isOpenBullet = !this.isOpenBullet
          }

          if (targetElement === 'bullet-mes') {
            const wxUserInfo = JSON.parse(window.sessionStorage.getItem('wxUserInfo'))
            if (wxUserInfo && wxUserInfo.openid && wxUserInfo.avatarInBE) {
              this.isShowBulletInput = true
              this.bulletShooting = false
            } else if(wxUserInfo && wxUserInfo.openid && !wxUserInfo.avatarInBE){
              this.$Modal.confirm({
                title:'头像获取失败',
                content:'您要重新获取吗',
                okText:'确定',
                cancelText:'取消',
                onOk:()=>{
                  const avatarImg = new Image()
                  avatarImg.src = wxUserInfo.headimgurl
                  avatarImg.onload = ()=>{
                    const cvs = document.createElement("canvas")
                    const ctx = cvs.getContext('2d')
                    cvs.width = avatarImg.width
                    cvs.height = avatarImg.height
                    ctx.drawImage(avatarImg, 0, 0, cvs.width, cvs.height)
                    cvs.toBlob(blob =>{
                      const imgFile = new File([blob], `${wxUserInfo.openid}.jpg`, {
                        type: blob.type
                      })
                      const fileData = {
                        file: imgFile,
                        type: 'wechat_avatar',
                        modelId: this.$route.query.id
                      }
                      //头像储存操作
                      this.$http('/api/file/open/upload', fileData, 'POST').then(res=>{
                        if(res.data.status === 200){
                          wxUserInfo.headimgurlBE = res.data.data.fileUrl
                          wxUserInfo.avatarInBE = true
                          window.sessionStorage.setItem('wxUserInfo', JSON.stringify(wxUserInfo))
                          this.$Message.error('微信用户头像获取成功')
                        }else{
                          this.$Message.error('微信用户头像获取失败')
                        }
                      }).catch(()=>{
                        this.$Message.error('微信用户头像获取异常')
                      })
                    },'image/jpeg', 1)
                  }
                }
              })
            } else if( !wxUserInfo ){
              this.$Modal.confirm({
                title: '微信无授权',
                content: '<p>您要授权吗?</p>',
                okText:'确定',
                cancelText:'取消',
                onOk: () => {
                  this.handleWX()
                }
              });
            }else{
              this.$Modal.confirm({
                title: '微信授权异常',
                content: '<p>您要重新授权吗?</p>',
                okText:'确定',
                cancelText:'取消',
                onOk: () => {
                  window.sessionStorage.removeItem('wxIsAuthorized')
                  this.handleWX()
                }
              });
            }
          }
        })
      } else {
        //非移动端,不做额外操作
      }

      this.e = (ev) => {
        if (ev.source !== window.parent) return;
        let data = ev.data;
        if (data.type === Events.SetSpeed) {
          this.setSpeed(data.msg.speed);
        } else if (data.type === Events.SetSpeedList) {
          this.setSpeedList(data.msg.speedList, data.msg.speed);
        }
      };
      window.addEventListener("message", this.e);
    },

    addListener() {
      // modelShow的props里的scene为true时才初始化
      this.scene && this.$refs.modelScene.initView(this.$refs.modelDemo._view);
      this.scene && this.$refs.modelScene.initSceneParam();

      // 场景自动播放控制
      this.$refs.modelDemo._view.pauseListener.add(this.moldePausePlay.bind(this));
      this.$refs.modelDemo._view.startAutoPlayListener.add(this.modelAutoPlay.bind(this))

      this.$refs.modelDemo._view.startAutoPlayListener.add(() => {parent.postMessage({type:Events.AutoPlayStart, msg: {}}, '*')})
      this.$refs.modelDemo._view.pauseListener.add(() => {parent.postMessage({type:Events.AutoPlayPause, msg: {}}, '*')})

      // 平面按钮
      this.isShowFlatButton = !this.$refs.modelDemo._camera.cameraMode;
      this.$refs.modelDemo._control.showSwitchListener.add(this.modelShowFlatButton.bind(this));
      this.$refs.modelDemo._control.hideSwitchListener.add(this.modelHideFlatButton.bind(this));

      //fix:修复flat动画bug用的变量
      this.isIn3D = this.isShowFlatButton;

      // 热点自动播放控制
      this.$refs.modelDemo._hpPlayer.events.on(Events.HotpointAnimationPlay, () => {
        this.$refs.modelDemo._hud.checkVR = true
        this.isPlayGuide = true
        this.modelPauseIcon = require('@/assets/img/icon/play.png');
        this.modelSpacePlayIcon = require('@/assets/img/icon/mobile-space-pause.png');
      });
      this.$refs.modelDemo._hpPlayer.events.on(Events.HotpointAnimationStop, () => {
        this.$refs.modelDemo._hud.checkVR = false
        this.isPlayGuide = false
        this.modelPauseIcon = require('@/assets/img/icon/pause.png');
        this.modelSpacePlayIcon = require('@/assets/img/icon/mobile-space-play.png');
      });

      // 自动心跳统计
      this.$refs.modelDemo._control.events.on(Events.Update, () => {
        const ts = Date.now() / 1000
        if (this.ts && ts - this.ts > config.Stastics.WaitTime) {
          this.ts = ts
          Statistic.heartbeat(this.$refs.modelDemo._camera.cameraCurrentIndex)
        }
      });

      // 游览点位统计
      this.$refs.modelDemo._control.events.on(Events.VisitPano, idx => {
        parent.postMessage({type:Events.VisitPano, msg: {id: idx}}, '*')
        Statistic.markPoint(idx)
      });

      // 游览点位统计
      this.$refs.modelDemo._control.events.on(Events.ToPano, idx => {
        // Statistic.markInteract(idx)
        Statistic.markPoint(idx)
      });

    },

    initCompass() {
      // 从配置中读入是否开启
      let compass = new Compass(this.settings.model.modelCompassAngle, this.$refs.modelDemo._camera);
      compass.showCompass = this.settings.model.isCompass
      compass.setCompass()
      this._compass = compass

      this.$refs.modelDemo._control.events.on(Events.To2D, () => {
        this._compass.setCompass()
      })
      this.$refs.modelDemo._control.events.on(Events.To3D, () => {
        this._compass.setCompass()
      })
      this.$refs.modelDemo._control.events.on(Events.ToPano, () => {
        this._compass.setCompass()
      })

      this.$refs.modelDemo._control.events.on(Events.Update, () => {
        this._compass.update()
      });
      console.log("Compass done")
    },

    initMeasure() {
      // 提前从配置中读入设置isMeasureable，决定测量功能是否开启
      if (!this.isMeasureable) return

      this.$refs.measure.init(this.$refs.modelDemo._control)
      this.$refs.measure.$on(Events.MeasureOn, () => {
        this.measureButton = true
      })
      this.$refs.measure.$on(Events.MeasureClose, () => {
        this.measureButton = false
      })
    },

    formatScene(setting) {
      let pointLength = setting.pointList.length;
      let imageLength = String(pointLength).length;

      // 场景列表
      const viewLs = []
      for (let item of setting.viewList) {
        viewLs.push({
          "view_id": item.viewId,
          "name": item.viewName,
          "view_cover_face_id": item.viewCoverFaceId,
          "view_cover_face_url": coverImagePath(setting.model.coverRoot, 'low', imageLength, (item.pointId + 1), item.viewCoverFaceId + 1) + '.jpg',
          "point_id": item.pointId,
          "view_angle": strToNumberArray(item.viewAngle),
          "view_order_id": item.viewOrderId
        })
      }
      return viewLs;
    },

    async startMediaPlay() {
      if(this.isSwitchMusic) {
        this.$refs.modelDemo._audioMgr.paused = false
      }
      if(this.isVoice) {
        this.$refs.modelDemo._audioMgr.intorPaused = false
      }
      for(let obj of this.$refs.modelDemo._exObjSet.objects) {
        obj.play && obj.play()
      }
    },

    async enterModel() {
      await this.$refs.modelDemo.enterScene()
      if (this.heatMap) {
        await this.$refs.modelDemo._control.transfer2D();
        this.$emit("SceneFinish");
        return;
      }
      if (this.settings.model.isAutoPlay) {
        this.autoPlay()
        this.$emit("SceneFinish");
      }
      this.ts = Date.now() / 1000
    },

    //点击切换平面
    changeModelFlat(index) {
      if (this.$refs.modelDemo._control.functionLock) return
      this.flat.forEach((value, key) => {
        if (key === index) {
          value.active = true;
          if (index === 0) {
            if (this.isMobile) {
              this.flat[0].src = require('@/assets/img/icon/mobile-flat-selected.png');
              this.flat[1].src = require('@/assets/img/icon/mobile-3D-select.png');
            } else {
              this.flat[0].src = require('@/assets/img/icon/flat-selected.png');
              this.flat[1].src = require('@/assets/img/icon/3D-unselect.png');
            }
            this.$refs.modelDemo._control.transfer2D();
            Statistic.markInteract(Statistic.InteractType.ToPanel);
            this.perspectiveChange = false;
          } else {
            if (this.isMobile) {
              this.flat[0].src = require('@/assets/img/icon/mobile-flat-select.png');
              this.flat[1].src = require('@/assets/img/icon/mobile-3D-selected.png');
              value.src = require('@/assets/img/icon/mobile-3D-selected.png');
            } else {
              this.flat[0].src = require('@/assets/img/icon/flat-unselect.png');
              this.flat[1].src = require('@/assets/img/icon/3D-selected.png');
              value.src = require('@/assets/img/icon/3D-selected.png');
            }
            this.$refs.modelDemo._control.transfer3D();
            Statistic.markInteract(Statistic.InteractType.To2D);
            this.perspectiveChange = true;
          }
        } else {
          value.active = false;
        }
      })
    },

    viewChange() {
      if (this.onGod) {
        this.$refs.modelDemo._control.toPano();
      } else {
        this.$refs.modelDemo._control.toGod();
      }
      return
    },

    // 给外部模块调用，用于实现平面按钮的显示
    modelShowFlatButton() {
      this.isIn3D = true;
      this.onGod = true
      setTimeout(() => {
        this.isShowFlatButton = true;
      }, 1200)
    },
    // 给外部模块调用，用于实现平面按钮的隐藏
    modelHideFlatButton() {
      this.onGod = false
      if (this.$refs.flatButton) {
        // this.$refs.flatButton.className = 'flat-button-box';
        this.isIn3D = false;
        setTimeout(() => {
          this.isShowFlatButton = false;
        }, 1700)
      }
    },
    //点击展开和收缩场景列表
    showSceneList() {
      this.sceneShow = !this.sceneShow;
      if (this.sceneShow) {
        this.sceneControllBottom = 190;
      } else {
        this.sceneControllBottom = 10;
      }
      // 当场景列表展开时，如果端移动空间是展开的则让其隐藏
      this.sceneShow && this.isShowPcRecommendSpace && (this.isShowPcRecommendSpace = false);
    },
    //点击实现场景自动播放
    autoPlay() {
      if(this.settings.model.modelPkId === 'vEFo4YRp' || this.settings.model.modelPkId === '2t4vQ2KZ') {
        if(!this.firstAutoPlay) {
          this.firstAutoPlay = true
          let idx = this.speedList.findIndex((v) => v.key == '0.2x')
          this.currentSpeed = this.speedList[idx].key;
          this.$refs.modelDemo._view.setTransitionTime(this.speedList[idx].value);
        }
      } else if(this.settings.model.modelPkId === 'Z4ewcrxY' || this.settings.model.modelPkId === 'LdKHiSJ1' || this.settings.model.modelPkId === 'MwNKyRWE') {
        if(!this.firstAutoPlay) {
          this.firstAutoPlay = true
          let idx = this.speedList.findIndex((v) => v.key == '0.5x')
          this.currentSpeed = this.speedList[idx].key;
          this.$refs.modelDemo._view.setTransitionTime(this.speedList[idx].value);
        }
      }
      this.isViewAutoPlay = true;
      this.isShowSpeedList = false;
      this.$refs.modelDemo._view.startAutoPlay();
    },
    //点击暂停播放
    pausePlay() {
      this.isViewAutoPlay = false;
      this.isShowSpeedList = false;
      this.$refs.modelDemo._view.stopAutoPlay();
    },
    //点击显示和隐藏倍数列表
    showSpeedList() {
      this.isShowSpeedList = !this.isShowSpeedList;
    },
    //点击选择对应的倍数
    selectSpeed(index) {
      this.currentSpeed = this.speedList[index].key;
      this.isShowSpeedList = false;
      this.$refs.modelDemo._view.setTransitionTime(this.speedList[index].value);
    },
    setSpeed(defaultSpeed) {
      let idx = this.speedList.findIndex((v) => v.key == defaultSpeed+'x');
      console.log("设定速度,"+idx+"为"+defaultSpeed)
      this.currentSpeed = this.speedList[idx].key;
      this.$refs.modelDemo._view.setTransitionTime(this.speedList[idx].value);
    },
    setSpeedList(sList, defaultSpeed) {
      let newList = [];
      for(let l of sList)
      {
        let v = 2000 / parseFloat(l);
        let k = l+'x'
        newList.push({key:k, value:v})
      }
      this.speedList= newList;
      this.setSpeed(defaultSpeed)
    },
    //点击显示和隐藏模型描述信息
    showModelDescription() {
      this.isShowModelDescription = !this.isShowModelDescription;
      if (this.isShowModelDescription) {
        // 二维码
        this.$nextTick(() => {
          this.qrcode(this.$refs.qrCodeDiv, 60);
        })
      }
    },
    //点击打开帮助指引信息弹窗
    openHelpInfoDialog() {
      this.isShowAnswerDialog = true;
      if (this.isMobile) {
        this.guideCloseIcon = require('@/assets/img/icon/guide-mobile-close.png');
      }
    },
    //关闭帮助信息弹窗
    closeHelpInfoDialog() {
      this.isShowAnswerDialog = false;
    },
    //点击开启和关闭音乐,此处的音乐自动播放，在谷歌和火狐浏览器不会自动播放，如果强制需要自动播放，需要在浏览器设置选项中设置允许自动播放音乐
    switchModelMusic() {
      let bgm = document.getElementById('model-bgm');
      if (this.isOffMusic && this.$refs.modelDemo._audioMgr.paused) {
        this.$refs.modelDemo._audioMgr.paused = false
        Statistic.markInteract(Statistic.InteractType.Music);
        if (this.isMobile) {
          this.$refs.musicIcon.src = require('@/assets/img/icon/mobile-music-on.png');
        } else {
          this.$refs.musicIcon.src = require('@/assets/img/icon/model-music-on.png');
        }
      } else {
        this.$refs.modelDemo._audioMgr.paused = true
        if (this.isMobile) {
          this.$refs.musicIcon.src = require('@/assets/img/icon/mobile-music-off.png');
        } else {
          this.$refs.musicIcon.src = require('@/assets/img/icon/model-music-off.png');
        }
      }
      this.isOffMusic = !this.isOffMusic;
    },
    //点击开启点位
    switchModelPosition() {
      this.isSwitchModelPosition = true;
    },
    //点击关闭模型点位
    closeModelPosition() {
      this.isSwitchModelPosition = false;
    },
    //点击显示和关闭弹幕(pc)
    switchBullet() {
      if (!this.isMobile) {
        this.isOpenBullet = !this.isOpenBullet
      }
    },
    //点击进入全屏
    enterFullScreen() {
      this.isFullScreen = !this.isFullScreen;
      if (this.isFullScreen) {
        let modelShow = document.getElementById('model-show');
        if (modelShow.requestFullscreen) {
          modelShow.requestFullscreen();
        } else if (modelShow.msRequestFullscreen) {
          modelShow.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        }
        this.$refs.fullScreenIcon.src = require('@/assets/img/icon/breviary_screen.png');
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.isFullScreen = false;
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          this.isFullScreen = false;
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          this.isFullScreen = false;
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          this.isFullScreen = false;
        }
        this.$refs.fullScreenIcon.src = require('../../assets/img/icon/fullscreen.png');
      }
    },
    //点击分享
    showShare() {
      // this.isShare = true;
    },
    //点击播放音乐
    playMusic() {
      let bgm = document.getElementById('model-bgm');
      let intor = document.getElementById('model-intor');
      this.$refs.modelDemo._audioMgr.init(bgm, intor)
      this.$refs.modelDemo._audioMgr.paused = true
      this.$refs.modelDemo._audioMgr.intorPaused = true
      return
    },
    //监听ESC
    listenESC() {
      let fullscreenStatus = document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
      if (!fullscreenStatus) {
        this.isFullScreen = false;
        this.$refs.fullScreenIcon.src = require('../../assets/img/icon/fullscreen.png');
      }
    },

    //pc端vr显示和隐藏
    showPcVr() {
      const ua = getPlatform()
      if (ua.platform === 'pc') {
        this.isShowPcVr = true;
        // 二维码
        this.$nextTick(() => {
          this.qrcode(this.$refs.qrCodeDivVr, 70);
        });
      }
    },
    hidePcVr() {
      this.isShowPcVr = false;
    },
    //显示和隐藏移动端vr
    showMobileVr() {
      if (this.isMobile) {
        this.isShowPcVr = false;
      }
    },
    openGravitySensor() {
      if (!this.$refs.modelDemo._camera.cameraMode) return // TODO用户提示框，上帝视角下不应该有重力感应
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission().then(permissionState => {
          if (permissionState === 'granted') {
            this.openGS()
          }
        }).catch((err) => {
          alert(err);
        });
      } else {
        this.openGS()
      }
    },
    openGS() {
      if (!this.gs) {
        const gs = new GravitySensor()
        gs.init()
        if (gs.readly) {
          this.$refs.modelDemo._control.addInput(gs)
          this.$refs.modelDemo._camera.isNoLimit = true
          this.gs = gs
        }
      } else {
        this.gs.depose()
        this.$refs.modelDemo._control.removeInput(this.gs)
        this.$refs.modelDemo._camera.isNoLimit = false
        this.gs = null
      }
    },
    openVR() {
      Statistic.markInteract(Statistic.InteractType.Vr)
      this.$refs.modelDemo._hud.checkVR = true
      this.$refs.modelDemo.enterVR()
      this.vrMode = true
      if (!this.gs) {
        this.openGravitySensor()
      }
    },
    exitVR() {
      this.$refs.modelDemo._hud.checkVR = false
      this.$refs.modelDemo.exitVR()
      this.vrMode = false
      if (this.gs) {
        this.openGravitySensor()
      }
    },
    //打开和关展馆简介
    closeDescription() {
      this.isShowModelDescription = false
    },
    //显示地图
    showMap() {
      Statistic.markInteract(Statistic.InteractType.Map)
      let key = config.Map.Token;
      let address = this.model.address;
      let url = `https://restapi.amap.com/v3/geocode/geo?address='${address}'&output=JSON&key=${key}`
      // 发送请求
      this.$http(url).then(res => {
        // 成功
        let position = res.data.geocodes[0].location.split(',');
        this.model.addressLocation.lon = position[0];
        this.model.addressLocation.lan = position[1];
        this.model.maps.center = [position[0], position[1]];
        this.model.maps.markpoint[0].name.content = address;
        this.model.maps.markpoint[0].name.offset = [0, 0];
        this.model.maps.markpoint[0].point = [position[0], position[1]];
      }, err => {
        // 失败
        this.$Message.error("地图获取失败")
        window.console.error(err)
      });
      this.isSwitchModelPosition = !this.isSwitchModelPosition;
    },
    //显示和隐藏移动端推荐空间
    showMobileSpace() {
      this.isShowSpace = true;
      this.$refs.sceneControllBar.style.display = 'none';
      this.$refs.modelSceneListBox.style.display = 'none';
      this.computeSpacePage();
    },
    //隐藏移动端推荐
    hideMobileSpace() {
      this.isShowSpace = false;
      this.$refs.sceneControllBar.style.display = 'flex';
      this.$refs.modelSceneListBox.style.display = 'flex';
      this.mobileDataList = [];
    },
    //外部调用暂停方法
    moldePausePlay() {
      this.isViewAutoPlay = false;
      if (this.isMobile) {
        this.$nextTick(() => {
          this.$refs.pauseIcon.src = require('@/assets/img/icon/mobile-pause.png');
        });
      }
      this.sceneShow = true;
    },
    //外部调用播放方法
    modelAutoPlay() {
      if (this.$refs.modelDemo._control.functionLock) return
      Statistic.markInteract(Statistic.InteractType.Play)
      this.isViewAutoPlay = true;
      this.isShowSpeedList = false;
      this.sceneShow = false;
    },
    playAnimate() {
      this.isPlayGuide = !this.isPlayGuide;
      // console.log(this.isPlayGuide)
      if (this.isPlayGuide) {
        this.modelPauseIcon = require('@/assets/img/icon/play.png');
        this.modelSpacePlayIcon = require('@/assets/img/icon/mobile-space-pause.png');
        this.$refs.modelDemo._hpPlayer.play()
      } else if (!this.isPlayGuide) {
        this.modelPauseIcon = require('@/assets/img/icon/pause.png');
        this.modelSpacePlayIcon = require('@/assets/img/icon/mobile-space-play.png');
        this.$refs.modelDemo._hpPlayer.stop()
      }
    },
    //点击切换空间
    changeSpace(index) {
      this.mobileRecommendLableList.forEach((value, key) => {
        if (key === index) {
          value.active = true;
          this.activeDataList = value.data;
          //调整推荐空间中的空间大小
          this.switchStyles();
        } else {
          value.active = false;
        }
      });
      this.computeSpacePage();
    },
    //动态计算空间的页数
    computeSpacePage() {
      this.mobileDataList = [];
      let mobileSpaceRecommendListWidth = getComputedStyle(this.$refs.mobileSpaceListBox, null).width.split('px')[0];
      let containCount = Math.floor(mobileSpaceRecommendListWidth / 80);
      let spaceArray = [];
      let startIndex = 0;
      this.indicatorCount = Math.ceil(this.activeDataList.length / containCount);
      this.swiperOptions.slidesPerview = this.indicatorCount;
      if (this.activeDataList.length > 0) {
        this.activeDataList.forEach((item, key) => {
          if (key % containCount === 0 && key !== 0) {
            this.mobileDataList.push(this.activeDataList.slice(startIndex, key));
            startIndex = key;
          }
          if ((key + 1) === this.activeDataList.length) {
            this.mobileDataList.push(this.activeDataList.slice(startIndex, (key + 1)));
          }
        });
        let spaceItemMargin = (mobileSpaceRecommendListWidth - 75 * containCount) / containCount / 2;
        this.$nextTick(() => {
          for (let i = 0; i < this.activeDataList.length; ++i) {
            this.$refs.mobileSpaceItem[i].style.margin = `0 ${spaceItemMargin}px 0 ${spaceItemMargin}px`;
          }
          this.$refs.mySwiper.$el.style.marginLeft = '0';
          this.$refs.mobileSpaceItem[0].parentNode.parentNode.style.width = this.mobileDataList[0].length * (this.$refs.mobileSpaceItem[0].getBoundingClientRect().width + getComputedStyle(this.$refs.mobileSpaceItem[0], null).marginRight.split('px')[0] * 2) + 'px';
        })
      }
    },
    //点击显示和隐藏Pc端移动空间
    showPcRecommendSpace() {
      this.isShowPcRecommendSpace = !this.isShowPcRecommendSpace;
      // 同步展开和收缩场景列表
      this.sceneShow = this.isShowPcRecommendSpace;
      this.showSceneList();
    },
    //发射弹幕
    shootBullet() {
      if (this.bulletValue === '') {
        this.$Message.warnig('弹幕不能为空')
        return
      }
      this.bulletShooting = true
      this.$refs.modelBullet.shootOne(this.bulletValue)
        .then(res => {
          this.bulletValue = ''
          this.bulletShooting = false
          this.isShowBulletInput = false
          this.isOpenBullet = true
        }, rej => {
          this.bulletValue = ''
          this.bulletShooting = false
        })
    },
    cancelShootBullet() {
      this.bulletShooting = false
      this.isShowBulletInput = false
    },
    // 根据移动端横屏显示右边工具栏位置
    // mobileHorizontalScreen() {
    //   // document.querySelector("#right-Bar").style.top = document.body.clientWidth < document.body.clientHeight ? '109.35px' : '10%';
    // },
    // 跳转至指定的推荐空间
    recommenedRedirect(item) {
      this.mobileRecommendLableList[0].active && window.open(config.hostAddress.rootIp + "?id=" + item.modelPkId, '_blank');
      this.mobileRecommendLableList[1].active && this.selectGuide(item);
    },
    // 切换推荐空间的内容样式
    switchStyles() {
      const spaceLength = this.activeDataList.length;
      if (spaceLength % 3 === 0) {
        this.$refs.spaceList && (this.$refs.spaceList.style.justifyContent = 'space-between');
      } else {
        this.$refs.spaceList && (this.$refs.spaceList.style.justifyContent = 'flex-start');
        for (let i = 0; i < spaceLength; i++) {
          if ((i + 1) % 3 !== 0) {
            this.$nextTick(() => {
              this.$refs.spaceListItem && (this.$refs.spaceListItem[i].style.marginRight = 14.5 + 'px');
            })
          }
        }
      }
    },
    // 选择Guide
    selectGuide(item) {
      this.$refs.modelDemo._hpPlayer.toHotpoint(item.hotpointId);
    },
    // 点击phone图标显示phone操作
    showPhoneOption() {
      if (this.isMobile) {
        Statistic.markInteract(Statistic.InteractType.Phone);
        this.isShowPhoneOption = !this.isShowPhoneOption;
      }
    },
    // copy
    copyContent() {
      let save = function (e) {
        e.clipboardData.setData('text/plain', this.model.phone);
        e.preventDefault();
      };
      document.addEventListener('copy', save);
      this.isShowPhoneOption = false;
      document.execCommand("copy");
    },
    // 返回链接页
    goBack() {
      window.open(this.returnLink, "_self");
    },
    handleWX() {
      // 判断当前是否为微信浏览器
      if (this.isInWeixin) {
        //判断用户是否进入过授权页
        if (!JSON.parse(window.sessionStorage.getItem('wxIsAuthorized'))) {
          //若未进入过授权页,打上进入过授权页的标记,并跳转至授权页
          window.sessionStorage.setItem('wxIsAuthorized', 'true')
          const redirectUri = encodeURIComponent(location.href)
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state#wechat_redirect`
          // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri+'%3fid%3d'+this.$route.query.id}&response_type=code&scope=snsapi_userinfo&state#wechat_redirect`
        } else {
          //若进入过授权页
          //判断url是否携带code,若有,授权成功,用code向后端请求微信用户数据
          if (this.$route.query.code) {
            //确认授权
            const code = Array.isArray(this.$route.query.code)? this.$route.query.code[this.$route.query.code.length - 1] : this.$route.query.code
            this.$http('/api/wechat/getUserInfo', {
                code
              })
              .then(res => {
                return new Promise((resolve, reject) => {
                  if (res.data.status === 200) {
                    const wxUserInfo = JSON.parse(res.data.data)
                    if (!wxUserInfo.openid) {
                      this.$Message.error('获取微信授权异常')
                      return
                    }
                    window.sessionStorage.setItem('wxUserInfo', res.data.data)
                    const avatarImg = new Image()
                    avatarImg.src = wxUserInfo.headimgurl
                    avatarImg.onload = function () {
                      resolve(avatarImg)
                    }
                    avatarImg.onerror = function () {
                      this.$Message.error('用户头像加载异常')
                      reject()
                    }
                    avatarImg.onabort = function () {
                      this.$Message.error('用户头像加载异常')
                      reject()
                    }
                  } else {
                    this.$Message.error('获取微信授权失败')
                    reject()
                  }
                })
              })
              .catch(() => {
                this.$Message.error('获取微信授权异常')
              })
              .then(avatarImg => {
                return new Promise((resolve, reject) => {
                  const cvs = document.createElement("canvas")
                  const ctx = cvs.getContext('2d')
                  cvs.width = avatarImg.width
                  cvs.height = avatarImg.height
                  ctx.drawImage(avatarImg, 0, 0, cvs.width, cvs.height)
                  cvs.toBlob(blob => {
                    const wxUserId = JSON.parse(window.sessionStorage.getItem('wxUserInfo')).openid
                    const imgFile = new File([blob], `${wxUserId}.jpg`, {
                      type: blob.type
                    })
                    const fileData = {
                      file: imgFile,
                      type: 'wechat_avatar',
                      modelId: this.$route.query.id
                    }
                    resolve(fileData)
                  }, 'image/jpeg', 1)
                })
              })
              .catch(() => {
                this.$Message.error('用户头像加载异常')
              })
              .then(fileData => {
                return this.$http('/api/file/open/upload', fileData, 'POST')
              })
              .catch(() => {
                this.$Message.error('用户头像生成异常')
              })
              .then(res => {
                if (res.data.status === 200) {
                  const wxUserInfo = JSON.parse(window.sessionStorage.getItem('wxUserInfo'))
                  wxUserInfo.headimgurlBE = res.data.data.fileUrl
                  wxUserInfo.avatarInBE = true
                  window.sessionStorage.setItem('wxUserInfo', JSON.stringify(wxUserInfo))
                } else {
                  this.$Message.error('微信用户头像读取异常')
                }
              })
              .catch(() => {
                this.$Message.error('微信用户头像读取异常')
              })
          } else {
            //无code,用户拒绝授权,不做操作
          }
        }
      } else {
        //非微信浏览器,不做操作
      }
    },
    // 生成二维码
    qrcode(oDiv, size) {
      new QRCode(oDiv, {
        width: size,
        height: size,
        text: config.hostAddress.rootIp + '?id=' + getModelId(this), // 二维码地址
        colorDark: "#000", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
      })
    }
  },
  watch: {
    //将弹幕开启状态与弹幕控件图标联系
    isOpenBullet: function (newValue) {
      if (this.isMobile) {
        if (newValue) {
          this.switchBulletIcon = require('@/assets/img/icon/mobile-bullet-on.png')
          this.bulletOffIcon = require('@/assets/img/icon/bullet-off.png')
        } else {
          this.switchBulletIcon = require('@/assets/img/icon/mobile-bullet-off.png')
          this.bulletOffIcon = require('@/assets/img/icon/bullet-on.png')
        }
      } else {
        if (newValue) {
          this.switchBulletIcon = require('@/assets/img/icon/on-bullet.png');
        } else {
          this.switchBulletIcon = require('@/assets/img/icon/off-bullet.png');
        }
      }
    }
  },
  computed: {},
  beforeDestroy() {
    this.$refs.modelDemo.delete();
    window.removeEventListener('resize', this.listenESC);
    // getPlatform().platform !== 'pc' && window.removeEventListener('resize', this.mobileHorizontalScreen);
  }
}
</script>

<style scoped src='@/assets/css/components/ModelShow.css'></style>
